import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LandTitleDto, SubSubGroupDto, CategoryDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { Patch } from '@nestjs/common';
import { PipelineassetlinkComponent } from '../pipelinedetails/pipelineassetlink/pipelineassetlink.component';
import { PipelineGenericFacade } from '../../states/+pipeline-generic/pipeline-generic.facade';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { loadGateway } from './../../../../../gateway/src/lib/states/+gateway/gateway.actions';


@Component({
  selector: 'cradua-pipelineassetpopup',
  templateUrl: './pipelineassetpopup.component.html',
  styleUrls: ['./pipelineassetpopup.component.scss']
})
export class PipelineassetpopupComponent implements OnInit {


  pipelineassetForm: FormGroup;
  pipelineassetFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() pipelineasset = new EventEmitter<LandTitleDto[]>()
  @Output() deletePipelineAssetEvent = new EventEmitter<any>()
  @Output() emitClearLandTitle = new EventEmitter<any>();
  @Input() isLoadingLandTitle: boolean;
  landTitle$: Observable<LandTitleDto[]>;
  subsubgroups$: Observable<SubSubGroupDto[]>;
  categorys$: Observable<CategoryDto[]>;
  isLoadingLandTitle$: Observable<any>;
  searchedLandTitle: LandTitleDto[];
  pipelineassetslink2 = [];
  pipelinelink2: any[];
  filteredAssetFxn: Array<any> = [];
  selectedAssetFxnId: any;
    selectedPipelineAsset: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    AssetLinkList: any[]=[];
    task = '';
  subsubgroups: any[];
  categorys: any[];

    constructor(private fb: FormBuilder, public matdialogue: MatDialogRef<PipelineassetlinkComponent>,
      public pipelineGenericFacade: PipelineGenericFacade, public gatewayFacade: GatewayFacade) {}

    ngOnInit() {
      this.pipelineGenericFacade.loadGatewayById("PipelineAssetLink2").subscribe(pipeline => {
        this.pipelinelink2 = pipeline;
      });
      // this.subsubgroups$ = this.gatewayFacade.loadGateway("SubSubGroup");
      // this.categorys$ = this.gatewayFacade.loadGateway("Category");
      // this.landTitle$ = this.pipelineGenericFacade.loadGatewayWithoutId('LandTitle');
      this.gatewayFacade.loadGateway("SubSubGroup").subscribe(subsub => {
        this.subsubgroups = subsub;
      });
      this.gatewayFacade.loadGateway("Category").subscribe(category => {
        this.categorys = category;
      });
      this.createPipelineAssetForm();
    }

    protected findById = <T>(id: string) =>
    (fieldName: T) => fieldName["id"] === id; 
   
    onSearch(query) {
    // this.landTitle$ = this.pipelineGenericFacade.loadGateway('LandTitle', query);
    this.pipelineGenericFacade.loadGateway("LandTitle", query).subscribe(a => {
      const control = this.pipelineassetFormArray.get('PipelineAssetLinks') as FormArray;
     this.clearFormArray(this.pipelineassetFormArray.get('PipelineAssetLinks') as FormArray)
      a.forEach(e =>{
        // control.insert(0, this.fb.group(e));
        control.push(this.fb.group(e));
      })
          
      this.pipelineassetslink2 = a
      })
    }

    onViewTask(value: LandTitleDto) {
      this.task = 'create';
      this.pipelineassetForm.patchValue(value);
    }

    onTask(value) {
      // console.log('task ', value);
      if(value === 'create') {
        this.pipelineassetForm.reset();
        this.emitClearLandTitle.emit(value);
      }
        this.task = value;
    }

    createPipelineAssetForm() {
      this.pipelineassetForm = this.fb.group({
        LandName: ['', Validators.required],
        SubSubGroupId: [''],
        SubSubGroupName: [''],
        CategoryId: [''],
        CategoryName: [''],
        AutoSerialId: [''],
        SubscriberId: [''],
        SubscriptionUserId: [''],
        id: null
        });
        this.pipelineassetFormArray = this.fb.group({ PipelineAssetLinks: this.fb.array([])
          });
        // this.setPipelineAsset();
    }

  // method to display pipelineassets
  setPipelineAsset() {
    // console.log('for each: ', this.searchedLandTitle);
    const control  = this.pipelineassetFormArray.controls.PipelineAssetLinks as FormArray;
    this.pipelineassetslink2.forEach( e => {
      control.push(
        this.fb.group({
          LandName: e.LandName,
          SubSubGroupId: e.SubSubGroupId,
          SubSubGroupName: e.SubSubGroupName,
          CategoryId: e.CategoryId,
          CategoryName: e.CategoryName,
          AutoSerialId: e.AutoSerialId,
          SubscriberId: e.SubscriberId,
          SubscriptionUserId: e.SubscriptionUserId,
          // id: e.id
        })
      );
    });
  }

  // method to add PipelineAsset
  addPipelineAsset(value: LandTitleDto) {
    const control  = this.pipelineassetFormArray.controls.PipelineAssetLinks as FormArray;
    control.insert(0,
          this.fb.group({
            LandName: value.LandName,
            SubSubGroupId: value.SubSubGroupId,
            CategoryId: value.CategoryId,
            id: null
          })
       );
  }

  clearFormArray = (formArray: FormArray) => {
    const control = this.pipelineassetFormArray.controls.PipelineAssetLinks as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  addNew(formValue: LandTitleDto) {
    if(this.pipelineassetForm.invalid) {
    return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.pipelineassetFormArray.get('PipelineAssets')['controls'][this.selectedIndex].patchValue({LandName: formValue.LandName, SubSubGroupId: formValue.SubSubGroupId, CategoryId: formValue.CategoryId});
    } else {
      this.addPipelineAsset(formValue);
    }
    this.selectedIndex = null;
    this.pipelineassetForm.reset()
  }

  // protected findById = <T>(id: string) =>
  // (fieldName: T) => fieldName["id"] === id; 


  getSubSubGroupName(id: string) {
    if(id) {
      return this.subsubgroups.find(this.findById<SubSubGroupDto>(id)) ? this.subsubgroups.find(this.findById<SubSubGroupDto>(id))
      .SubSubGroupName : null;
    }
      return null;
    
  }

  getCategoryName(id: string) {
    if(id) {
      return this.categorys.find(this.findById<CategoryDto>(id)) ? this.categorys.find(this.findById<CategoryDto>(id))
      .CategoryName : null;
    }
      
      return null;
  }

  onEdit(index, value: LandTitleDto) {
    this.selectedIndex = index;
  }
 
  onClearForm() {
    this.selectedIndex = null;
    this.pipelineassetForm.reset();
  }

  onClose() {
    this.matdialogue.close();
  }

  checkSelected(LandName) {
    const check =  this.pipelinelink2.find(a => a.LandName === LandName);
    return check ? true : false;
  }

  checkPipelineAsset(value) {
    const listdata = [];
    const data  = {
      SubSubGroupName: "",
      CategoryName: "", 
      LandName: value.LandName,
      SubSubGroupId: value.SubSubGroupId,
      CategoryId: value.CategoryId,
      id: value.id,
    };
    const subgroup = this.subsubgroups.find(sub => sub.id === value.SubSubGroupId);
    const category =  this.categorys.find(cat => cat.id === value.CategoryId);
    
    if(subgroup) {
      data.SubSubGroupName = subgroup.SubSubGroupName
    }
    if(category) {
      data.CategoryName = category.CategoryName
    }

    listdata.push(data);
    this.AssetLinkList.unshift(listdata);
  }

  onSubmit() {
    this.matdialogue.close(this.AssetLinkList)
  }

}
